<template>
</template>

<script>
import configip from "../../static/config.json";

export default {
  name: "AutoLogin",
  data() {
    return {};
  },
  created: function() {
    this.autoLogin();
  },
  methods: {
    autoLogin() {
      //获取链接参数
      let redirectUrlType = this.$route.query.redirectType;

      let _this = this;
      //根据token获取用户信息，加入缓存
      this.$api.post(
        "/login/InsUserByToken",
        "token=" +
          this.$route.query.token +
          "&once=" +
          this.$route.query.once +
          "&timestamp=" +
          this.$route.query.timestamp +
          "&sign=" +
          this.$route.query.sign,
        function(res) {
          //console.log(res);
          if (res.Ret == 0) {
            localStorage.setItem("autoLoginInfo", JSON.stringify(res.Data));
            var data = res.Data;
            var postData = "insCode=" + data.InsCode;
            var url = "/register/GetInsTestProp";
            console.log(_this);
            _this.$api.post(url, postData, response => {
              if (response.Ret == 0) {
                sessionStorage.setItem("insTestProp", JSON.stringify(response.Data));
                _this.$router.push({
                  path:
                    "/login/" +
                    data.InsCode +
                    "?redirectType=" +
                    redirectUrlType
                });
              } else {
                _this.$alert(response.Msg);
              }
             });
           
          } else {
            // alert(res.Msg);
            _this.$alert(res.Msg, {
              callback: action => {
                window.location.replace("about:blank");
              }
            });
          }
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AutoLogin.vue